export const checkIsEmail = (value: string) => value && /@/.test(value);